import React from 'react';
import { UserIcon, CalendarIcon } from 'lucide-react';
export function Hero() {
  const scrollToProducts = () => {
    const productsSection = document.getElementById('products-section');
    if (productsSection) {
      productsSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="w-full bg-gradient-to-b from-gray-50 to-white py-12" data-id="element-217">
      <div className="max-w-4xl mx-auto px-4" data-id="element-218">
        <div className="text-sm text-gray-600 mb-4" data-id="element-219">
          Product Reviews &gt; Padel Club Review &gt; Elbow Braces for Padel
        </div>
        <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 leading-tight" data-id="element-220">
          5 Best Elbow Braces for Padel in the UK (2025 Tested & Ranked)
        </h1>
        <p className="text-xl text-gray-600 mb-8" data-id="element-221">
          We compared the UK's most popular padel elbow braces for pain relief,
          comfort, and durability - here's what we found.
        </p>
        <div className="flex flex-wrap items-center gap-4 text-sm text-gray-600 mb-6" data-id="element-222">
          <div className="flex items-center gap-2" data-id="element-223">
            <UserIcon className="w-4 h-4" data-id="element-224" />
            <span data-id="element-225">BY LUKE MITCHELL</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-226">
            <CalendarIcon className="w-4 h-4" data-id="element-227" />
            <span data-id="element-228">UPDATED: 29 October 2025</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-229">
            <UserIcon className="w-4 h-4" data-id="element-230" />
            <span data-id="element-231">
              TESTED BY DR. JAMES THORNTON, SR. SPORTS MEDICINE SPECIALIST
            </span>
          </div>
        </div>
        <div className="text-center mb-8" data-id="element-232">
          <button onClick={scrollToProducts} className="bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-8 rounded-lg transition-colors" data-id="element-233">
            Jump To Products
          </button>
        </div>
        <div className="w-full" data-id="element-234">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/fjQdJrkyEHjv1fyph6XEvk/banner.webp" alt="Padel players banner" className="w-full h-auto rounded-lg" data-id="element-235" />
        </div>
      </div>
    </div>;
}